export default __webpack_public_path__ + "assets/patient-component.3fae71d8.svg";